import { Select } from "@mantine/core";
import { useMemo } from "react";
import { useHealthScoreSettings } from "../../../../hooks/QueryHooks";

type HealthModelFilterProps = {
  workspaceId: string;
  value: string;
  onChange: (value: string) => void;
};

const HealthModelFilter = ({ workspaceId, value, onChange }: HealthModelFilterProps) => {
  const { data: settings } = useHealthScoreSettings({ workspaceId }) as {
    data: { models?: Array<{ scope_key: string; scope_type: string; scope_label: string; scope_source_label: string }> } | undefined;
  };

  const options = useMemo(() => {
    const base = [{ value: "all", label: "All models" }];
    if (!settings?.models?.length) return base;

    const modelOptions = settings.models.map((m) => ({
      value: m.scope_key,
      label:
        m.scope_type === "general"
          ? "General"
          : `${m.scope_source_label}: ${m.scope_label}`,
    }));

    return [...base, ...modelOptions];
  }, [settings]);

  return (
    <Select
      size="xs"
      w={200}
      value={value}
      onChange={(val) => onChange(val || "all")}
      data={options}
      placeholder="Health model"
    />
  );
};

export default HealthModelFilter;
